<div class="side-panel" [ngClass]="{'active' : isPanelActive}">
  <div class="panel-header">
    <button class="close-btn" (click)="togglePanel()"></button>
  </div>
  <div class="panel-content">
    <ng-content></ng-content>
  </div>
</div>

<div class="overlay" [ngClass]="{'active' : isPanelActive}" (click)="togglePanel()"></div>
